import { Component, OnInit } from '@angular/core';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-admin-services-pricing',
  templateUrl: './admin-services-pricing.component.html',
  styleUrls: ['./admin-services-pricing.component.scss'],
})
export class AdminServicesPricingComponent implements OnInit {
  pricingType: any = 'CUSTOMER';
  service: any;
  servicesList: any = [];
  services: any = [];
  accountOwners: any;
  accountOwner: any;
  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private api: ApiIntegration) {
    this.g.loaderDisplay = "display";
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });

  }
  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  getOrgList() {
    this.g.loaderDisplay = "display";
    this.api.getAdditionalPrices("1", this.service).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.services = data;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }
  getList() {
    this.g.loaderDisplay = "display";
    this.api.customerGetAdditionalPrices(this.accountOwner, "1", this.service).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.servicesList = data;
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }
  ngOnInit() { }

  clear() {
    this.accountOwner = '';
    this.service = '';
    this.servicesList.tier1MinQuantity = '';
    this.servicesList.tier2MinQuantity = '';
    this.servicesList.tier3MinQuantity = '';
    this.servicesList.tier4MinQuantity = '';
    this.servicesList.tier5MinQuantity = '';
    this.servicesList.tier6MinQuantity = '';
    this.servicesList.tier7MinQuantity = '';
    this.servicesList.tier8MinQuantity = '';
    this.servicesList.tier8RecurringCharge = '';
    this.servicesList.tier7RecurringCharge = '';
    this.servicesList.tier6RecurringCharge = '';
    this.servicesList.tier5RecurringCharge = '';
    this.servicesList.tier4RecurringCharge = '';
    this.servicesList.tier3RecurringCharge = '';
    this.servicesList.tier2RecurringCharge = '';
    this.servicesList.tier1RecurringCharge = '';
  }

  fulfillmentSave() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAdditionalPriceForAO', this.servicesList,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Pricing', 'Updated Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  orgSave() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAdditionalPriceForOrg', this.services,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Pricing', 'Updated Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
